module.exports = __webpack_public_path__ + "img/02刘忠东.abcfc343.png";